import { inject, Injectable } from '@angular/core';

import { UserType } from '@/app/api/users';
import { AuthStore } from '@/app/core/store/auth';

@Injectable({
  providedIn: 'root',
})
export class AccessService {
  authStore = inject(AuthStore);

  private get user() {
    return this.authStore.authUser();
  }

  hasType(type: UserType): boolean {
    return this.authStore.authUser()?.type === type;
  }

  hasAnyTypes(roles: UserType[]): boolean {
    return roles.includes(this.authStore.authUser()?.type);
  }
}
